// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:29:45Z                      #

// ##############################################################

import ErrorApi from "./../../../utils/ErrorApi";
import Fetch from "./../../../utils/Fetch";
import ParamsFetch from "./../../../utils/ParamsFetch";
import JsonFetch from "./../../../utils/JsonFetch";
import generateUrl from './../../../utils/generateUrl';

import * as UpdateMethods from "./UpdateMethods";

/**
 * Autofill Controller Uložení/Načtení předvyplnovaných dat Generated from cz.marbes.uzn.AutofillController.
 */
export default class AutofillApi {
    /**
     * Uložení dat na server - cesta -> hodnota
     *
     * @param data Data k uložení
     */
    static save(data : {[key: string]: Object}) {
        const uri = serverContextPath + `/api/autofill`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, data, headers));
    }

    /**
     * Načtení dat pomocí cest ze stromu
     *
     * @param pathLists cesty
     * @return Mapa dat cest
     */
    static load(pathLists : string[]) : Promise<{[key: string]: Object}> {
        const uri = serverContextPath + `/api/autofill`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, pathLists, headers));
    }

}